/** Multi-device protocol — SPEC §5.4 / FR-DEV-* (local QR link/approve/revoke; sync incomplete). */

export type DeviceTrustState = "pending" | "trusted" | "revoked";

export interface DeviceRecord {
  deviceId: string;
  name: string;
  platform: "web" | "ios" | "android" | "desktop";
  fingerprint: string;
  trustState: DeviceTrustState;
  lastSeenAt: number;
  revokedAt?: number;
  /**
   * FR-DEV-001 approval certificate: Ed25519 signature (hex, 128 chars) by the
   * account messaging key over the canonical approval bytes (challenge,
   * fingerprint, device ids, timestamp). Absent on the implicit self record
   * (this device holds the keys) and on pre-certificate registries.
   */
  approvedByDeviceId?: string;
  approvedAt?: number;
  approvalSigHex?: string;
  /** Offer challenge the approval binds (public QR material, needed to re-verify). */
  approvalChallenge?: string;
}

export interface DeviceLinkOffer {
  v: 1;
  type: "device.link.offer";
  /** Out-of-band QR payload (FR-DEV-002). */
  challenge: string;
  newDeviceFingerprint: string;
  platform: DeviceRecord["platform"];
  name: string;
  expiresAt: number;
}

export interface DeviceLinkApprove {
  v: 1;
  type: "device.link.approve";
  challenge: string;
  certificate: string;
  approvedByDeviceId: string;
}

export interface DeviceRevokeEvent {
  v: 1;
  type: "device.revoke";
  deviceId: string;
  /** Must trigger session/sender-key rotation (FR-DEV-003). */
  rotateSessions: true;
}

export const DEVICE_FEATURE_STATUS = {
  linking: "partial",
  revocation: "partial",
  availableInUi: true,
  gateMessage:
    "Link a new device by sharing an approval code. After revoking a device, re-open chats to refresh security.",
} as const;
